import React from "react";

export function StatusColumnFormatter(cellContent, row, rowIndex, { updateStatus, superadmin, processing }) {
  const callUpdateStatus = (row, value) => {
    updateStatus(row.id, value);
  };

  if (processing === row.id) {
    return <i className="fas fa-circle-notch fa-spin text-primary"></i>;
  }

  const isActive = row.status === "active" || row.status === 0 || row.status === "0";

  if (superadmin) {
    return (
      <select
        className={`form-control form-control-sm font-weight-bold ${
          isActive ? "text-success border-success" : "text-danger border-danger"
        }`}
        style={{ width: "110px", borderRadius: "6px" }}
        value={isActive ? "active" : "inactive"}
        onChange={(e) => callUpdateStatus(row, e.target.value)}
      >
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    );
  }

  return (
    <span
      className={`label label-lg font-weight-bold label-inline ${
        isActive ? "label-light-success" : "label-light-danger"
      }`}
    >
      {isActive ? "Active" : "Inactive"}
    </span>
  );
}